module.exports = __webpack_public_path__ + "cb29742114fa3d702608256db267275a.ttf";